import {useMutation} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';

export default function useGetPlayerDetails(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation(
    async ({uuid, tournamentId}: {uuid: string; tournamentId: string}) => {
      const response = await TournamentRestClient.get(
        `/players/details?uuid=${uuid}&tournamentId=${tournamentId}`,
      );
      console.log(response.data, 'useGetPlayerDetails response');

      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return mutation;
}
